// extracted by mini-css-extract-plugin
var _1 = "ra-vertical-menu-overlay-btn";
var _2 = "ra-vertical-menu-overlay";
export { _1 as "verticalMenuOverlayBtnCls", _2 as "verticalMenuOverlayCls" }
